import React, { useEffect } from 'react';
import { createPortal } from 'react-dom';
import { FiX } from 'react-icons/fi';
import { useCommunity } from '../../contexts/CommunityContext';
import { useLanguage } from '../../i18n';
import GoogleLogin from '../GoogleLogin';
import { BLUE_GRADIENT } from './brand';

/**
 * Sign in / sign up for the Mini Shop Community — **Google only**.
 *
 * No form at all on purpose: a form is what bots hammer (fake accounts, brute
 * force, load). “Continue with Google” signs a member in and the API creates the
 * community account on the first visit, from the verified Google email — see
 * `Backend_API/routers/social_auth.py`. `openAuth('signin', reason)` from the
 * feed still opens this modal with the reason shown on top.
 */
export default function CommunityAuthModal() {
  const { t } = useLanguage();
  const { authOpen, authReason, closeAuth } = useCommunity();

  useEffect(() => {
    if (!authOpen) return undefined;
    const prev = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => { document.body.style.overflow = prev; };
  }, [authOpen]);

  if (!authOpen) return null;

  return createPortal(
    <div className="fixed inset-0 z-[1100] flex items-center justify-center p-4">
      <div className="absolute inset-0 bg-black/70 backdrop-blur-sm anim-fade-in" onClick={closeAuth} />
      <div className="relative w-full max-w-sm rounded-2xl bg-white dark:bg-gray-900 shadow-2xl anim-modal">
        <div className="px-6 pt-6 pb-4 text-center" style={{ background: BLUE_GRADIENT }}>
          <img src={`${process.env.PUBLIC_URL}/ckl.png`} alt="CodeKhmerLearning" className="w-14 h-14 mx-auto drop-shadow" />
          <h2 className="mt-2 text-white font-extrabold text-lg">{t('community')}</h2>
          <p className="text-white/85 text-xs mt-0.5">{t('communityTagline')}</p>
          <button
            type="button"
            onClick={closeAuth}
            className="absolute top-3 right-3 p-1.5 rounded-lg bg-white/15 text-white hover:bg-white/25"
            aria-label="Close"
          >
            <FiX className="w-4 h-4" />
          </button>
        </div>

        <div className="px-6 py-6">
          {authReason && (
            <p className="mb-4 text-xs rounded-lg px-3 py-2 text-center"
              style={{ background: '#0b3d9118', color: '#0b3d91' }}>
              {authReason}
            </p>
          )}

          <p className="text-sm text-center text-gray-500 dark:text-gray-400 mb-3">
            {t('googleOnlyLogin')}
          </p>
          <GoogleLogin scope="community" />
        </div>
      </div>
    </div>,
    document.body,
  );
}
